// Shared copy for trial/usage states.

// Short countdown label for an active trial, e.g. "Trial: 5 days left".
export function trialDaysLeftLabel(trialEndsAt) {
  if (!trialEndsAt) return 'Trial active';
  try {
    const ms = new Date(trialEndsAt).getTime() - Date.now();
    if (ms <= 0) return 'Trial ended';
    const days = Math.ceil(ms / 86400000);
    return days <= 1 ? 'Trial: last day' : `Trial: ${days} days left`;
  } catch {
    return 'Trial active';
  }
}
